export type VpcFeatureSet = {
  region: string;
  vpc_enabled: boolean;
  public_subnets_enabled: boolean;
};

export type VpcResourceCheck = {
  region: string;
  publicSubnet: boolean;
};

export type VpcChangeChecks = {
  resourceChecks: VpcResourceCheck[];
  // True only when every VPC in the account ends up disabled
  allVpcsDisabled: boolean;
};

export function getVpcChangeChecks(
  currentVpcs: VpcFeatureSet[],
  updatedVpcs: VpcFeatureSet[],
): VpcChangeChecks {
  const resourceChecks: VpcResourceCheck[] = [];
  let allVpcsDisabled = true;

  currentVpcs.forEach(vpc => {
    const updatedEntry = updatedVpcs.find(entry => entry.region === vpc.region);

    if (vpc.vpc_enabled === true && updatedEntry?.vpc_enabled !== true) {
      // VPC disabled in this region, check all resources
      resourceChecks.push({ region: vpc.region, publicSubnet: false });
    } else if (
      vpc.public_subnets_enabled === true &&
      updatedEntry?.public_subnets_enabled !== true
    ) {
      // Only the public subnet disabled in this region, check only that
      resourceChecks.push({ region: vpc.region, publicSubnet: true });
    }

    // Any VPC that remains enabled means Route 53 records are unaffected
    if (updatedEntry?.vpc_enabled === true) {
      allVpcsDisabled = false;
    }
  });

  return { resourceChecks, allVpcsDisabled };
}
